import AuthLayout from "@/components/layouts/AuthLayout";
import VerificationForm from "@/panel/auth/VerificationForm";
import SendVerificationForm from "@/forms/SendVerificationForm";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { toast } from "sonner";

export default function VerificationPage() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectPath = searchParams.get("redirect") || "/login";

  const onVerified = () => {
    toast.success("Email verified successfully.");
    navigate(`${redirectPath}?email=${encodeURIComponent(email)}`);
  };

  const handleEmailSent = (email: string) => {
    setEmail(email);
  };

  return (
    <AuthLayout>
      {!email && (
        <SendVerificationForm
          handleEmailSent={handleEmailSent}
          handleVerified={onVerified}
        />
      )}
      {email && <VerificationForm handleVerified={onVerified} email={email} />}
    </AuthLayout>
  );
}
